import { useQuery } from "@tanstack/react-query";
import { fetchWithError } from "../fetchWithError";
import { queryKeys } from "../queryKeys";

export const useCharger = (chargedId, query = '', options = {}) => {
  return useQuery(queryKeys.charger(chargedId, query), fetchWithError, {
    enabled: !!chargedId,
    keepPreviousData: true,
    ...options,
  });
};